import { render } from "./ProductOptionsKiosk.vue?vue&type=template&id=2b38ccd8&scoped=true"
import script from "./ProductOptionsKiosk.vue?vue&type=script&lang=js"
export * from "./ProductOptionsKiosk.vue?vue&type=script&lang=js"

import "./ProductOptionsKiosk.vue?vue&type=style&index=0&id=2b38ccd8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Sebastian\\Desktop\\-taptasty-order\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b38ccd8"]])

export default __exports__